import { LocalizedTextDisplayModel } from '@/api/model-index';
import { InfotextDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/infotext-display-model';
import { I18nService } from '@/core/services/i18nService';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { Component, HostListener, OnInit } from '@angular/core';

@Component({
    selector: 'infotext-tooltip',
    templateUrl: './infotext-tooltip.component.html',
    styleUrls: ['./infotext-tooltip.component.scss']
})
export class InfotextTooltipComponent implements OnInit {
    visible: boolean = false;
    InfotextKey: string = "";
    InfoText: InfotextDisplayModel | undefined = undefined;
    isPopoverOpen: boolean = false;

    constructor(protected stammdatenService: StammdatenService, protected languageservice: I18nService) { }

    ngOnInit(): void {
        this.InfoText = this.stammdatenService.InfoTexte?.getValue(this.InfotextKey);
        if (this.InfoText) {
            this.visible = true;
        }
        else {
            this.visible = false;
        }
    }

    get InfotextBeschreibung() {
        let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.InfoText?.beschreibung);
        return title?.text ?? "";
    }

    get showBaseTitle(): boolean {
        return this.InfoText?.name?.find(name => name.text && name.text.length > 0) == undefined;
    }

    get InfotextTitle(): string {
        let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.InfoText?.name)
        return title?.text ?? "";
    }

    @HostListener('click') onMouseEnter() {

    }

    @HostListener('click') onMouseLeave() {

    }
}
